import { useState, useEffect } from 'react';

export function useSearchSuggestions(query, products, limit = 5) {
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    if (query.length > 1) {
      const filtered = products.filter(p => 
        p.label.toLowerCase().includes(query.toLowerCase()) ||
        p.brand.toLowerCase().includes(query.toLowerCase()) ||
        p.ref.toLowerCase().includes(query.toLowerCase())
      ).slice(0, limit);
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [query, products, limit]);

  return { suggestions, showSuggestions, setShowSuggestions };
}
